import { render, staticRenderFns } from "./faq.vue?vue&type=template&id=b8fa1fd0&scoped=true&"
import script from "./faq.vue?vue&type=script&lang=ts&"
export * from "./faq.vue?vue&type=script&lang=ts&"
import style0 from "./faq.scss?vue&type=style&index=0&id=b8fa1fd0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8fa1fd0",
  null
  
)

component.options.__file = "faq.vue"
export default component.exports